/**
 * Footer widget component.
 * @class FooterComponent
 */
import { Component, Input, ViewEncapsulation, HostListener } from '@angular/core';

@Component({
    selector: 'myp-footer',
    templateUrl: './footer.component.html',
    encapsulation: ViewEncapsulation.None
})
export class FooterComponent {
  @Input('footerLogo') footerLogo:boolean;
 }
